import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

export const MUTATION = graphql(`
  mutation onlineOrder_changeHappyHourMode($id: ID!, $mode: HappyHourMode!) {
    onlineOrder_changeHappyHourMode(id: $id, mode: $mode) {
      branchID
    }
  }
`);

export default function useChangeHappyHourMode() {
  return useMutation(MUTATION, {});
}
